import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "install-for-use-flex" }
const _hoisted_2 = { class: "context" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createElementVNode("a", { id: "dec-install" }, [
    /*#__PURE__*/_createElementVNode("span", null, "2.1 Installation of the DEC Hub")
  ])
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "(1) Open the installation file and select the software permission.")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "(2) Select the DEC Hub installation path.")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "(3) After setting the path, click “Install”and wait for the installation to be completed.")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createElementVNode("a", { id: "dec-use" }, [
    /*#__PURE__*/_createElementVNode("span", null, "2.2 Usage of the DEC Hub")
  ])
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("a", { id: "dec-login" }, [
    /*#__PURE__*/_createElementVNode("span", null, "2.2.1 Sign-in of the DEC Hub")
  ])
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "(1) Sign-in with the verification code / account ")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, " Sign-in with the verification code: It is only applicable to the [mobile phone number + SMS verification code]. ", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", null, " Sign-in with the account: It is applicable to the [mobile phone number + password] and [email address + password]. ", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, " ", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "(2) LAN sign-in", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "After purchasing the Pro Edition or Enterprise Edition service, you can sign in to the DEC Hub with the authorization method distributed by the IP address.")
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("a", { id: "dec-major" }, [
    /*#__PURE__*/_createElementVNode("span", null, [
      /*#__PURE__*/_createElementVNode("span", null, [
        /*#__PURE__*/_createElementVNode("span", null, [
          /*#__PURE__*/_createElementVNode("span", null, [
            /*#__PURE__*/_createElementVNode("span", null, "2.2.2 ")
          ])
        ])
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "Activating the Pro Edition")
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "After sign-in, click “Activate Pro Edition”to complete the activation and use the service.")
], -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "(1) Enter the number of devices to be activated")
], -1)
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<p><a name=\"_Toc10675\"><span>Note: In Section 1, it shows the number of devices that can be authorized in the current month. When the number of devices signed in through the LAN exceeds the number of authorized devices, the exceeded part of devices cannot use the DEC service.</span></a></p><p><span>(2) After set up, click “Activate” to activate successfully.</span></p><h3><a id=\"add-platform-number\"><span><span><span><span><span>2.2.3 </span></span></span></span></span></a><span>Increasing the number of authorized devices per day</span></h3><p><a name=\"_Toc11800\"><span>(1) [Devices] – Click &quot;Increase&quot; to set the number of authorized devices.</span></a></p>", 4)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "You can enter the number of devices to be increased in Section 1.")
], -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "In Section 2, it shows the required deduction balance of the increased devices.")
], -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Click “Confirm” to complete the setting.")
], -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("a", { name: "_Toc10675" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Note: The maximum number of authorized devices per day for the Pro Edition is 50; if you need more devices, please contact us for the Enterprise Edition service.")
  ])
], -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("a", { id: "dec-major-1" }, [
    /*#__PURE__*/_createElementVNode("span", null, "2.2.4")
  ]),
  /*#__PURE__*/_createElementVNode("span", null, " LAN authorization of the Pro Edition")
], -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", null, " (1) [Devices] Please share the LAN sign-in address with the users who need to be authorized in the same LAN. Then they can sign in to the DEC Hub with LAN sign-in address. ", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", null, " (2) When there are multiple LAN sign-in addresses, please confirm that the LAN sign-in address and the user's IP address are in the same LAN. (as shown in the screenshot below). ", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", null, " (3) Each LAN user acquiring services through the Admin account will occupy one quota of the number of authorized devices per day. ", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("p", null, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("a", { id: "dec-compant" }, [
    /*#__PURE__*/_createElementVNode("span", null, "2.2.5")
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "LAN authorization of the Trial Version.")
], -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("p", null, "It is in the same way as the LAN authorization of the Pro Edition.", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("a", { id: "dec-download" }, [
    /*#__PURE__*/_createElementVNode("span", null, [
      /*#__PURE__*/_createElementVNode("span", null, [
        /*#__PURE__*/_createElementVNode("span", null, [
          /*#__PURE__*/_createElementVNode("span", null, "2.3 ")
        ])
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "DEC Installation")
], -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("p", null, " (1) After sign-in to the DEC Hub, click “Install Dec” to install the DEC Hub. ", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("p", null, " (2) When the progress bar has finished loading, the installation is successfully completed. ", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("a", { id: "open-dec" }, [
    /*#__PURE__*/_createElementVNode("span", null, [
      /*#__PURE__*/_createElementVNode("span", null, [
        /*#__PURE__*/_createElementVNode("span", null, [
          /*#__PURE__*/_createElementVNode("span", null, [
            /*#__PURE__*/_createElementVNode("span", null, "2.4 ")
          ])
        ])
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "Starting the DEC")
], -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("p", null, " (1) Click \"Start DEC\" in the DEC Hub, and MAYA will be automatically opened. ", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("p", null, " (2) Open in sequence Windows → Settings/Preferences → Plug-in Manager in the MAYA function menu. ", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("p", null, " (3) Find and tick the DEC plug-in of the corresponding version in the Plug-in Manager. ", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("p", null, " (4) After ticking the DEC plug-in, the corresponding functions of the DEC will appear in the function menu. ", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("p", null, " (5) Select the starting virtual engine version (currently only supports UE) and select the program/project file to be opened. ", -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("p", null, " When the setting is completed, open & load the virtual engine and open the program. ", -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("p", null, " (6) You have access to the DEC service after opening the virtual engine. ", -1)


export default /*#__PURE__*/_defineComponent({
  __name: 'InstallForUseEn',
  setup(__props) {

const imageList = {
  image1: require("../../assets/en-document-images/3ab9714156694080b72d2c5ea4e17a1e.jpg"),
  image2: require("../../assets/en-document-images/1e80e011f1b945a6877ee3794819b1f3.jpg"),
  image3: require("../../assets/en-document-images/e32d2ca7543f4d03a281094ce5489bd9.jpg"),
  image4: require("../../assets/en-document-images/87025be9653b4deaa928c8105e8c1478.jpg"),
  image5: require("../../assets/en-document-images/6ac7ddb39c3f40f5ac41fcedf919e091.jpg"),
  image6: require("../../assets/en-document-images/16e95c1283604f369d65a41cf3ea9a94.png"),
  image7: require("../../assets/en-document-images/04c339853e6240acadd4ee1021063278.jpg"),
  image8: require("../../assets/en-document-images/a70a3e7b02f843a0810f99f7c6ceb2ed.jpg"),
  image9: require("../../assets/en-document-images/f79b6301ac6e43f4b0f2fe99aac20a8b.jpg"),
  image10: require("../../assets/en-document-images/8ae10e4a78f748e982674e84a904d8a5.jpg"),
  image11: require("../../assets/en-document-images/b200fe147a214d3898ae25f8c1414514.jpg"),
  image12: require("../../assets/en-document-images/971c952a37a84968b271a61729a82d79.jpg"),
  image13: require("../../assets/en-document-images/62ac5d0a00124f689861971dc1048e73.jpg"),
  image14: require("../../assets/en-document-images/602925430cd543049bf7318a95e656e5.jpg"),
  image15: require("../../assets/en-document-images/a74c523d7f5d48ba80663c065cdbec80.jpg"),
  image16: require("../../assets/en-document-images/23514457708d483d879f6daed5341860.jpg"),
  image17: require("../../assets/en-document-images/cd1da6f77f494fd992ca707b57be0700.jpg"),
  image18: require("../../assets/document-images/654798c6dbf6410e9c1552a5f1078ad2.jpg"),
  image19: require("../../assets/en-document-images/bdf3873b77b84aaf932d22fd54e4dfaf.jpg"),
};

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("p", null, [
        _createVNode(_component_el_image, {
          src: imageList.image1,
          "preview-src-list": [imageList.image1],
          fit: "contain"
        }, null, 8, ["src", "preview-src-list"])
      ]),
      _hoisted_5,
      _createElementVNode("p", null, [
        _createElementVNode("span", null, [
          _createVNode(_component_el_image, {
            src: imageList.image2,
            "preview-src-list": [imageList.image2],
            fit: "contain"
          }, null, 8, ["src", "preview-src-list"])
        ])
      ]),
      _hoisted_6,
      _hoisted_7,
      _hoisted_8,
      _hoisted_9,
      _createElementVNode("p", null, [
        _createElementVNode("span", null, [
          _createVNode(_component_el_image, {
            src: imageList.image3,
            "preview-src-list": [imageList.image3],
            fit: "contain"
          }, null, 8, ["src", "preview-src-list"])
        ])
      ]),
      _hoisted_10,
      _hoisted_11,
      _hoisted_12,
      _createElementVNode("p", null, [
        _hoisted_13,
        _createElementVNode("span", null, [
          _createVNode(_component_el_image, {
            src: imageList.image4,
            "preview-src-list": [imageList.image4],
            fit: "contain"
          }, null, 8, ["src", "preview-src-list"])
        ])
      ]),
      _hoisted_14,
      _hoisted_15,
      _hoisted_16,
      _createElementVNode("p", null, [
        _createElementVNode("span", null, [
          _createVNode(_component_el_image, {
            src: imageList.image5,
            "preview-src-list": [imageList.image5],
            fit: "contain"
          }, null, 8, ["src", "preview-src-list"])
        ])
      ]),
      _hoisted_17,
      _hoisted_18,
      _createElementVNode("p", null, [
        _createElementVNode("span", null, [
          _createVNode(_component_el_image, {
            src: imageList.image6,
            "preview-src-list": [imageList.image6],
            fit: "contain"
          }, null, 8, ["src", "preview-src-list"])
        ])
      ]),
      _hoisted_19,
      _createElementVNode("p", null, [
        _createElementVNode("span", null, [
          _createVNode(_component_el_image, {
            src: imageList.image7,
            "preview-src-list": [imageList.image7],
            fit: "contain"
          }, null, 8, ["src", "preview-src-list"])
        ])
      ]),
      _createElementVNode("p", null, [
        _createElementVNode("span", null, [
          _createVNode(_component_el_image, {
            src: imageList.image8,
            "preview-src-list": [imageList.image8],
            fit: "contain"
          }, null, 8, ["src", "preview-src-list"])
        ])
      ]),
      _hoisted_23,
      _hoisted_24,
      _hoisted_25,
      _hoisted_26,
      _hoisted_27,
      _createElementVNode("p", null, [
        _createElementVNode("span", null, [
          _createVNode(_component_el_image, {
            src: imageList.image9,
            "preview-src-list": [imageList.image9],
            fit: "contain"
          }, null, 8, ["src", "preview-src-list"])
        ])
      ]),
      _hoisted_28,
      _hoisted_29,
      _createElementVNode("p", null, [
        _createElementVNode("span", null, [
          _createVNode(_component_el_image, {
            src: imageList.image10,
            "preview-src-list": [imageList.image10],
            fit: "contain"
          }, null, 8, ["src", "preview-src-list"])
        ])
      ]),
      _hoisted_30,
      _hoisted_31,
      _hoisted_32,
      _hoisted_33,
      _createElementVNode("p", null, [
        _createElementVNode("span", null, [
          _createVNode(_component_el_image, {
            src: imageList.image11,
            "preview-src-list": [imageList.image11],
            fit: "contain"
          }, null, 8, ["src", "preview-src-list"]),
          _createVNode(_component_el_image, {
            src: imageList.image12,
            "preview-src-list": [imageList.image12],
            fit: "contain"
          }, null, 8, ["src", "preview-src-list"])
        ])
      ]),
      _hoisted_34,
      _hoisted_35,
      _createElementVNode("p", null, [
        _createElementVNode("span", null, [
          _createVNode(_component_el_image, {
            src: imageList.image13,
            "preview-src-list": [imageList.image13],
            fit: "contain"
          }, null, 8, ["src", "preview-src-list"])
        ])
      ]),
      _createElementVNode("p", null, [
        _createElementVNode("span", null, [
          _createVNode(_component_el_image, {
            src: imageList.image14,
            "preview-src-list": [imageList.image14],
            fit: "contain"
          }, null, 8, ["src", "preview-src-list"])
        ])
      ]),
      _hoisted_36,
      _hoisted_37,
      _hoisted_38,
      _createElementVNode("p", null, [
        _createElementVNode("span", null, [
          _createVNode(_component_el_image, {
            src: imageList.image15,
            "preview-src-list": [imageList.image15],
            fit: "contain"
          }, null, 8, ["src", "preview-src-list"])
        ])
      ]),
      _hoisted_39,
      _createElementVNode("p", null, [
        _createElementVNode("span", null, [
          _createVNode(_component_el_image, {
            src: imageList.image16,
            "preview-src-list": [imageList.image16],
            fit: "contain"
          }, null, 8, ["src", "preview-src-list"])
        ])
      ]),
      _hoisted_40,
      _createElementVNode("p", null, [
        _createElementVNode("span", null, [
          _createVNode(_component_el_image, {
            src: imageList.image17,
            "preview-src-list": [imageList.image17],
            fit: "contain"
          }, null, 8, ["src", "preview-src-list"])
        ])
      ]),
      _hoisted_41,
      _hoisted_42,
      _createElementVNode("p", null, [
        _createElementVNode("span", null, [
          _createVNode(_component_el_image, {
            src: imageList.image18,
            "preview-src-list": [imageList.image18],
            fit: "contain"
          }, null, 8, ["src", "preview-src-list"])
        ])
      ]),
      _createElementVNode("p", null, [
        _createElementVNode("span", null, [
          _createVNode(_component_el_image, {
            src: imageList.image19,
            "preview-src-list": [imageList.image19],
            fit: "contain"
          }, null, 8, ["src", "preview-src-list"])
        ])
      ]),
      _hoisted_43,
      _hoisted_44
    ])
  ]))
}
}

})